<template>
  <LineLink
    v-bind="$attrs"
    class="PrimaryLineLink"
  >
    <slot />
  </LineLink>
</template>

<style lang="postcss">
.PrimaryLineLink {
  &::after {
    transition: opacity 0.3s ease-in-out;
    opacity: 0.3;
  }

  &:hover::after {
    opacity: 1;
  }
}
</style>
